import { useEffect } from 'react';
import { useChatStore } from './useChatStore';

// Bindet den gespeicherten Chat an den angemeldeten User.
export function useChatOwner(userId: string | undefined): boolean {
  const isOwner = useChatStore(
    (state) => userId !== undefined && state.userId === userId,
  );
  const setUser = useChatStore((state) => state.setUser);

  useEffect(() => {
    if (userId) {
      setUser(userId);
    }
  }, [userId, setUser]);

  return isOwner;
}
